import { Home, Users, LogOut, X, Rows4, ExternalLink, FileUser } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Logo from '../Images/GT.svg'
const AdminSidebar = ({ closeSidebar }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/admin");
  };

  const goTo = (path) => {
    navigate(path);
    if (closeSidebar) closeSidebar();
  };

  return (
    <div className="w-64 h-screen bg-pink-100 shadow-lg flex flex-col justify-between">
      <div className="p-6">
        {/* Mobile Close Button */}
        <div className="flex justify-between items-center lg:hidden mb-6">
          <h2 className="text-2xl font-[Poppins] text-pink-700">Admin</h2>
          <button onClick={closeSidebar}>
            <X size={20} />
          </button>
        </div>

        {/* Desktop Title */}
        {/* <h2 className="hidden lg:block text-2xl text-pink-700 font-[500] font-[Poppins] mb-6">
          Admin Panel
        </h2> */}

        <img src={Logo} alt="" />

        <nav className="space-y-4 font-[Poppins] mt-10">
          <div
            onClick={() => goTo("/admin/dashboard")}
            className="flex items-center gap-3 text-gray-800 hover:text-pink-600 cursor-pointer"
          >
            <Home size={20} />
            <span>Dashboard</span>
          </div>
          <div
            onClick={() => goTo("/admin/users")}
            className="flex items-center gap-3 text-gray-800 hover:text-pink-600 cursor-pointer"
          >
            <Users size={20} />
            <span>Users</span>
          </div>
          <div
            onClick={() => goTo("/admin/blogmanagement")}
            className="flex items-center gap-3 text-gray-800 hover:text-pink-600 cursor-pointer"
          >
            <Rows4 size={20} />
            <span>Blog Management</span>
          </div>
          <div
            onClick={() => goTo("/admin/career")}
            className="flex items-center gap-3 text-gray-800 hover:text-pink-600 cursor-pointer"
          >
            <ExternalLink size={20} />
            <span>Career</span>
          </div>
          <div
            onClick={() => goTo("/admin/jobapply")}
            className="flex items-center gap-3 text-gray-800 hover:text-pink-600 cursor-pointer"
          >
            <FileUser size={20} />
            <span>Job applied</span>
          </div>
        </nav>
      </div>

      <div className="p-6 border-t">
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 text-white bg-red-500 p-3 rounded-full hover:text-red-700 font-medium"
        >
          <LogOut size={20} />
          Logout
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;
